import * as React from "react";
import {
  BooleanField,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  NumberField,
  TextField,
  TextInput,
} from "react-admin";
import { DateTimeField } from "lib/components/DateTime";
import {
  PUBLISHED_ENTITY_COLOR,
  UNPUBLISHED_ENTITY_COLOR,
} from "../../utils";

const programFilters = [
  <TextInput label="Title" source="title" style={{ minWidth: "200px" }} alwaysOn />,
  <TextInput label="Slug" source="slug" style={{ minWidth: "200px" }} alwaysOn />,
  <TextInput
    label="Instructor"
    source="instructorName"
    style={{ minWidth: "200px" }}
    alwaysOn
  />,
];

function rowStyle(record) {
  return {
    backgroundColor: record.hidden
      ? UNPUBLISHED_ENTITY_COLOR
      : PUBLISHED_ENTITY_COLOR,
  };
}

export function ProgramList(props) {
  return (
    <List
      {...props}
      perPage={50}
      sort={{ field: "publishDate", order: "DESC" }}
      bulkActionButtons={false}
      filters={programFilters}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField source="slug" />
        <TextField source="title" />
        <TextField source="level" />
        <FunctionField
          label="Style"
          render={(record) => record.style || "—"}
          source="style"
        />
        <TextField source="instructorName" label="Instructor" />
        <NumberField source="totalClassesCount" label="Classes" />
        <BooleanField source="isFree" label="Free" />
        <DateTimeField source="publishDate" label="Publish Date" />
        <EditButton color="secondary" basePath="/programs" />
      </Datagrid>
    </List>
  );
}
